import { last } from "lodash";
import { useEffect, useState } from "react";
import { getColorFromInitial } from "../../utils/Utils";
import { UserDetailModal } from "./UserDetailModal";
import { useImageLoader } from "../customHook/ImageLoader";
import { Avatar, Spin } from "antd";
import { OnlineCircle } from "./OnlineCircle";

const MessageAvatar = ({
  person,
  size = 50,
  index,
  styleCss = { position: "absolute" },
  isCircle = true,
}) => {
  const [briefName, setBriefName] = useState();
  const [isOpenModalUserDetail, setIsOpenModalUserDetail] = useState(false);
  const { imageUrl, loading: isImageLoading } = useImageLoader(person?.avatar);

  const handleOpenModalUserDetail = () => {
    setIsOpenModalUserDetail(true);
  };

  useEffect(() => {
    setBriefName(
      last(person?.name?.trim()?.split(" "))?.[0] ||
        last(person?.username?.trim()?.split(" "))?.[0] ||
        "U",
    );
  }, [person]);

  if (isImageLoading) {
    <Avatar
      style={{
        zIndex: 10 - index,
        width: size,
        height: size,
        borderRadius: "50%",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 15,
        color: "#fff",
        fontWeight: 500,
        userSelect: "none",
        ...styleCss,
      }}
      icon={<Spin></Spin>}
    ></Avatar>;
  }

  return (
    <>
      <div className={`relative`}>
        <Avatar
          style={{
            zIndex: 10 - index,
            width: size,
            height: size,
            borderRadius: "50%",
            backgroundColor: getColorFromInitial(briefName),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 15,
            color: "#fff",
            fontWeight: 500,
            userSelect: "none",
            ...styleCss,
          }}
          size={size}
          src={imageUrl}
          className={"cursor-pointer"}
          onClick={handleOpenModalUserDetail}
        >
          {briefName}
        </Avatar>
        {isCircle && (
          <OnlineCircle
            userId={person?.userId}
            size={size > 40 ? "medium" : "small"}
          />
        )}
      </div>
      {isOpenModalUserDetail && (
        <UserDetailModal
          person={person}
          isOpen={isOpenModalUserDetail}
          handleCancel={() => setIsOpenModalUserDetail(false)}
        />
      )}
    </>
  );
};
export { MessageAvatar };
